<div id="content">
    <div class="titlebox">Spec Rx</div>
    <br><br>
    <div>
        <ag-grid-angular [headerHeight]="35" [rowHeight]="35" style="height: 500px; width: 100%;" (rowDoubleClicked)="navigate($event)" class="ag-theme-alpine" [rowData]="rowSpecRx" [columnDefs]="columnSpecRx">
        </ag-grid-angular>
    </div>
</div>